import axios from 'axios';

const YOUTUBE_API_KEY = 'AIzaSyDC9WFtKdAjZW9jUvMJFEh6hftimRhWSds';
axios.defaults.baseURL = "https://youtube.googleapis.com/youtube/v3";

export const getChannelRecentVideos = async (channelId, amount = 4) => {
  try {
    const response = await axios.get("/search", {
      params: {
        key: YOUTUBE_API_KEY,
        part: "snippet",
        channelId: channelId,
        order: "date",
        maxResults: amount,
        type: 'video'
      }
    });
    return response.data.items;
  } catch (error) {
    console.error("YouTube API Error:", error);
    throw error;
  }
}; 